module.exports = __webpack_public_path__ + "img/logo-round.9ef93969.png";